import type { ActiveSideFiltersType } from '@fiverr-private/listing_types';
import { shouldFilterNavigate } from '../../../../../service/clientNavigation';
import { applyTopBarFilters } from '../../utils';
import type { FilterRowItemData } from '../FilterRow.types';

type DropdownMenuProps = Extract<FilterRowItemData, { type: 'dropdown' }>['props'];

export const buildPillDropdownProps = (
    currencySymbol: string,
    activeFilters: ActiveSideFiltersType
): DropdownMenuProps => ({
    activeFilters,
    additionalProps: { currencySymbol, usePillButton: true },
    navigationCondition: shouldFilterNavigate,
    applyNavigation: applyTopBarFilters,
    trackOpen: true,
    usePillButton: true,
});
